import * as React from "react";
import styled from "styled-components";
import useAuthenticatedFetch from '../../hooks/useAuthenticatedFetch';
import { useAuth } from '../../AuthContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommunitySelectDialog from '../dialogs/CommunitySelectDialog';

export function UserProfile({ user }) {
  const [communityData, setCommunityData] = React.useState(null);
  const [userData, setUserData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [showDialog, setShowDialog] = React.useState(false);
  const [communities, setCommunities] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const fetchWithAuth = useAuthenticatedFetch();
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Fonction pour extraire le prénom du nom complet
  const getFirstName = (fullName) => {
    if (!fullName) return '';
    return fullName.split(' ')[0]; // Prend le premier mot du nom complet
  };

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
    // Récupérer les communautés de l'utilisateur
    fetchWithAuth(`${process.env.REACT_APP_BASE_URL}/community/getUserCommunities/${user.userId}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Erreur lors de la récupération des communautés");
        }
      })
      .then((communitiesData) => {
        if (communitiesData.length > 1) {
          setCommunities(communitiesData);
          setShowDialog(true);
        }
      })
      .catch((error) => {
        console.error("Erreur de réseau :", error);
      });
  };

  const handleCommunitySelect = (community) => {
    login({ ...user, communityId: community.id });
    setShowDialog(false);
    navigate("/AdminDashboard");
  };

  React.useEffect(() => {
    // Récupérer les informations de l'utilisateur
    fetchWithAuth(`${process.env.REACT_APP_BASE_URL}/user/info`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Erreur lors de la récupération des données utilisateur");
        }
      })
      .then((data) => {
        setUserData(data);
      })
      .catch((error) => {
        console.error("Erreur de réseau :", error);
      });

    // Récupérer les données de la communauté
    fetch(`${process.env.REACT_APP_BASE_URL}/community/getCommunityById/${user.communityId}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Erreur lors de la récupération des données de la communauté");
        }
      })
      .then((data) => {
        setCommunityData(data);
      })
      .catch((error) => {
        console.error("Erreur de réseau :", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [user.communityId]);

  if (loading) {
    return <div>Chargement...</div>;
  }

  return (
    <>
      <ProfileWrapper onClick={handleProfileClick} style={{ cursor: 'pointer' }}>
        {communityData && userData && (
          <>
            <Avatar
              loading="lazy"
              src={`${communityData.logoPath}`}
              alt={`${communityData.name}'s logo`}
            />
            <UserName>{getFirstName(userData.fullName)}</UserName>
          </>
        )}
      </ProfileWrapper>

      <CommunitySelectDialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        communities={communities}
        onCommunitySelect={handleCommunitySelect}
      />
    </>
  );
}

const ProfileWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

const UserName = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;